import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { listUserTasksQuery } from '@shared/services/gql.service';

export type UserTasksModel = getEntityType<listUserTasksQuery>;

export type UserTasksState = EntityState<listUserTasksQuery>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ idKey: 'task_id', name: 'user-tasks' })
export class UserTasksStore extends EntityStore<UserTasksState> {
  constructor() {
    super({});
  }
}
